// Design tokens of the guided onboarding, mirrored from the design handoff
// (prototype/shared.jsx). The palette matches the Mobilizei Design System —
// green/black/Cabin already live in src/theme.js; these are the extra tokens
// the onboarding needs and the MUI theme does not expose.

export const COLORS = {
    green: '#3CD568',
    greenDark: '#2BAA4F',
    forest: '#0A4D20',
    text: '#000',
    textMuted: 'rgba(0,0,0,0.6)',
    textSubtle: 'rgba(0,0,0,0.45)',
    border: 'rgba(0,0,0,0.23)',
    divider: 'rgba(0,0,0,0.12)',
    surfaceMuted: '#f5f5f5',
    surfaceDisabled: '#e6e6e6',
    successBg: '#a5d6a7',
    successFg: '#22543d',
    warningBg: '#fff9c4',
    warningFg: '#744210',
    errorBg: '#faedeb',
    errorFg: '#cc4b37',
    infoBg: '#2196f3',
    android: '#2cc69d',
    ios: '#1c93c3'
}

// The stepper counts 7 steps; the signup is the entry door ("step 0").
export const TOTAL_STEPS = 7
